import React, { useState, useEffect } from "react";
import { Modal, Table, Spinner } from "react-bootstrap";
import { getUpdateSalesOrderHistory } from "../../services/maintain-bid-service";

const UpdateSalesOrderHistoryModal = ({ show, onHide, enquiry }) => {
  const [loading, setLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    if (show && enquiry) {
      fetchHistory();
    }
  }, [show, enquiry]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const data = await getUpdateSalesOrderHistory(enquiry.EnquiryNumber, enquiry.CustomerEmail);
      setHistoryData(data);
    } catch (error) {
      console.error("Error fetching history:", error);
      setHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Update Sales Order History - {enquiry?.EnquiryNumber}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>User ID</th>
                <th>User Name</th>
                <th>Sales Order Number</th>
                <th>Date Time</th>
              </tr>
            </thead>
            <tbody>
              {historyData.length > 0 ? (
                historyData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.LoggedBy}</td>
                    <td>{item.LoggedByName}</td>
                    <td>{item.SONumber}</td>
                    <td>{item.LoggedOn}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">No history found</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default UpdateSalesOrderHistoryModal;